import React from 'react';


const CustomerStatusCard = ({ icon, dueDay, customerText, noOfCustomers, dueDate,customers, noOfOrdersClassName, dropDown}) => {



    return (
        <section>
            <div className='order-status-card-container'>
                <div className='flex gap-4'>
                    <div>{icon}</div>
                    <p className='due-text'>{customerText}</p>
                    <section>
                        
                        {dropDown}
                    </section>
                </div>
                <div className='flex gap-20 mt-7'>
                    <div>
                        <p className={`no-of-orders ${noOfOrdersClassName}`}>{noOfCustomers} <span className='orders-text'>{customers}</span> </p>
                    </div>
                    {/* <p className='size mt-7 ml-7'>{size}{unit}</p> */}
                </div>
            </div>
        </section>
    );
}

export default CustomerStatusCard;
